import { WhoIsFormField } from '../Steps/WhoIsThisAccountFor/WhoIsThisAccountFor';
import {
  WorkflowActions,
  WorkflowCurrentStepFC,
  WorkflowData,
} from '../../AutoAccountWorkflow.types';
import { BirthdateFormField } from '../Steps/YourDateOfBirth/YourDateOfBirth';
import { PartnerDataFormField } from '../Steps/PartnerData/PartnerData';
import { TotalInvestableAssetsFormField } from '../Steps/TotalValueInvestableAssets/TotalValueInvestableAssets';

export interface FormFields
  extends WhoIsFormField,
    BirthdateFormField,
    PartnerDataFormField,
    TotalInvestableAssetsFormField {}

export interface UseLongTermWorkflowData extends WorkflowData<WorkflowCurrentStepFC> {}

export interface UseLongTermWorkflowActions
  extends WorkflowActions<
    WhoIsFormField | BirthdateFormField | PartnerDataFormField | TotalInvestableAssetsFormField
  > {}

export enum StepKey {
  WhoIsFor = 'whoIsFor',
  Birthday = 'birthday',
  Partner = 'partner',
  TotalValue = 'totalValue',
  HowMuchSaved = 'HowMuchSaved',
}

export type Step = (formValues: FormFields) => WorkflowCurrentStepFC;

export type StepMap = Record<StepKey, Step>;

export type ValidationPerStep = Record<StepKey, Array<keyof FormFields>>;
